var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.379519 0.379517C0.885542 -0.126506 1.70597 -0.126506 2.21199 0.379517L19.6205 17.788C20.1265 18.294 20.1265 19.1144 19.6205 19.6205C19.1144 20.1265 18.294 20.1265 17.788 19.6205L0.379519 2.21199C-0.126504 1.70597 -0.126504 0.88554 0.379519 0.379517Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.379517 19.6205C-0.126506 19.1145 -0.126506 18.294 0.379517 17.788L17.788 0.379538C18.294 -0.126485 19.1144 -0.126485 19.6205 0.379538C20.1265 0.885561 20.1265 1.70599 19.6205 2.21201L2.21199 19.6205C1.70596 20.1265 0.88554 20.1265 0.379517 19.6205Z"
});

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.f3747d29.svg";
export { ForwardRef as ReactComponent };